import { Locale } from "../../../../../locales/types";
import de from "./de-DE.svg";
import en from "./en-GB.svg";
import fr from "./fr-FR.svg";
import pt from "./pt-BR.svg";

const GooglePlayIcon: Record<Locale, SVGElement> = {
  "en-GB": en,
  "de-DE": de,
  "fr-FR": fr,
  "pt-BR": pt,
};

export default GooglePlayIcon;
